import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isAppUserOrganisationsLoading = (state: TRootState): boolean =>
  arrayContains(state.appUser.openRequests, [
    Actions.findAppUserOrganisationsRequest.type,
    Actions.assignAppUserOrganisationRequest.type,
    Actions.removeAppUserOrganisationRequest.type,
  ]);
